export const PromotionTypes = {
  IS_FOR_ALL:        '1bf61851-347c-4d0d-a62e-d488dce9c0da',
  PROMO_PRODUCT:     '2bf61851-347c-4d0d-a62e-d488dce9c0da',
  IS_FOR_RETAIL:     '3bf61851-347c-4d0d-a62e-d488dce9c0da',
};